(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const variants = JSON.parse(root.querySelector('[data-nlc-variants]').textContent);
    const byId = new Map(variants.map(v => [String(v.id), v]));
    const form = root.querySelector('.nlc-bundle-form');
    const cards = [...root.querySelectorAll('[data-bundle]')];
    const button = form.querySelector('button[type=submit]');
    const error = root.querySelector('.nlc-cart-error');
    const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en-US', {style: 'currency', currency: root.dataset.currency || 'USD'}).format(cents / 100);
    const fallbackVariant = variants.find(v => v.available) || variants[0];
    const sharedSelect = form.querySelector('[data-shared-variant]');
    let galleryVariantId = sharedSelect ? String(sharedSelect.value) : String(fallbackVariant && fallbackVariant.id || '');
    const variantDd = form.querySelector('[data-variant-dd]');
    const syncVariantDropdown = (variantId) => {
      if (!variantDd || !sharedSelect) return;
      const variant = byId.get(String(variantId)) || fallbackVariant;
      if (!variant) return;
      sharedSelect.value = String(variant.id);
      galleryVariantId = String(variant.id);
      const triggerThumb = variantDd.querySelector('[data-variant-dd-thumb]');
      const triggerLabel = variantDd.querySelector('[data-variant-dd-label]');
      if (triggerLabel) triggerLabel.textContent = variant.title || '';
      if (triggerThumb) {
        const src = variant.featured_image && variant.featured_image.src;
        if (src) {
          let img = triggerThumb.querySelector('img');
          if (!img) { img = document.createElement('img'); img.alt = ''; triggerThumb.replaceChildren(img); }
          img.src = src;
          img.removeAttribute('srcset');
        } else {
          triggerThumb.replaceChildren();
        }
      }
      variantDd.querySelectorAll('[data-variant-dd-option]').forEach(opt => {
        const on = String(opt.dataset.variantId) === String(variant.id);
        opt.classList.toggle('is-selected', on);
        opt.setAttribute('aria-selected', String(on));
      });
    };
    const initVariantDropdown = () => {
      if (!variantDd || !sharedSelect) return;
      const trigger = variantDd.querySelector('[data-variant-dd-trigger]');
      const menu = variantDd.querySelector('[data-variant-dd-menu]');
      if (!trigger || !menu) return;
      const close = () => { menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
      const open = () => { menu.hidden = false; trigger.setAttribute('aria-expanded', 'true'); };
      trigger.addEventListener('click', () => { if (menu.hidden) open(); else close(); });
      menu.querySelectorAll('[data-variant-dd-option]').forEach(opt => {
        opt.addEventListener('click', () => {
          if (opt.getAttribute('aria-disabled') === 'true') return;
          syncVariantDropdown(opt.dataset.variantId);
          close();
          sharedSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      document.addEventListener('click', event => {
        if (!variantDd.contains(event.target)) close();
      });
      syncVariantDropdown(sharedSelect.value);
    };
    const syncSharedFollowers = () => {
      if (!sharedSelect) return;
      const sharedId = String(sharedSelect.value);
      form.querySelectorAll('[data-follow-shared]').forEach(el => { el.value = sharedId; });
    };
    const normalizeSrc = (src) => String(src || '').split('?')[0].replace(/_\d+x(?=\.|$)/, '');
    const activateGalleryIndex = (index) => {
      if (index == null || index < 0) return;
      const key = String(index);
      root.querySelectorAll('[data-gallery-index]').forEach(t => {
        const active = t.dataset.galleryIndex === key;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', String(active));
      });
      root.querySelectorAll('[data-image-index]').forEach(image => {
        image.classList.toggle('is-active', image.dataset.imageIndex === key);
      });
    };
    const showVariantImage = (variant) => {
      if (!variant) return;
      const featured = variant.featured_image;
      const thumbs = [...root.querySelectorAll('[data-gallery-index]')];
      let index = -1;
      if (featured) {
        if (featured.id != null) {
          index = thumbs.findIndex(t => String(t.dataset.imageId) === String(featured.id));
        }
        if (index < 0 && featured.position != null) {
          index = Number(featured.position) - 1;
        }
        if (index < 0 && featured.src) {
          const want = normalizeSrc(featured.src);
          const file = want.split('/').pop();
          index = [...root.querySelectorAll('[data-image-index] img')].findIndex(img => {
            const src = normalizeSrc(img.currentSrc || img.src);
            return src === want || (file && src.includes(file));
          });
        }
      }
      if (index < 0 && variant.title) {
        const parts = String(variant.title).toLowerCase().split(/[-–|/,]/).map(s => s.trim()).filter(s => s.length > 2);
        for (const part of parts.slice().reverse()) {
          index = thumbs.findIndex(t => {
            const img = t.querySelector('img');
            if (!img) return false;
            const hay = ((img.alt || '') + ' ' + (img.currentSrc || img.src || '')).toLowerCase();
            return hay.includes(part);
          });
          if (index >= 0) break;
        }
      }
      if (index >= 0) activateGalleryIndex(index);
    };

    const selections = card => {
      if (Number(card.dataset.bundle) === 1 && sharedSelect) {
        const shared = byId.get(String(sharedSelect.value)) || fallbackVariant;
        return [shared];
      }
      const picked = [...card.querySelectorAll('[data-variant-select]')].map(el => byId.get(String(el.value))).filter(Boolean);
      if (picked.length) return picked;
      const qty = Number(card.dataset.bundle) || 1;
      return Array.from({ length: qty }, () => fallbackVariant);
    };
    const refresh = () => {
      syncSharedFollowers();
      const chosen = Number(form.querySelector('input[name=nlc_bundle]:checked').value);
      cards.forEach(card => {
        card.classList.toggle('is-selected', Number(card.dataset.bundle) === chosen);
        const selected = selections(card);
        const full = selected.reduce((sum, v) => sum + v.price, 0);
        const total = Math.round(full * (100 - Number(card.dataset.percentage)) / 100);
        card.querySelector('[data-bundle-price]').textContent = money(total);
        const shipping = card.querySelector('[data-free-shipping]');
        if (shipping) shipping.hidden = root.dataset.currency !== 'USD';
        if (card.querySelector('[data-full-price]')) card.querySelector('[data-full-price]').textContent = money(full);
        if (card.querySelector('[data-savings]')) card.querySelector('[data-savings]').textContent = money(full - total);
      });
      const card = cards.find(c => Number(c.dataset.bundle) === chosen);
      const selected = selections(card);
      form.querySelector('input[name=id]').value = selected[0].id;
      form.querySelector('input[name=quantity]').value = chosen;
      root.querySelector('[data-unit-price]').textContent = money(selected[0].price);
      button.disabled = selected.some(v => !v.available);
      button.textContent = button.disabled ? root.dataset.unavailable : root.dataset.add;
      syncVariantDropdown(galleryVariantId || selected[0].id);
      showVariantImage(byId.get(String(galleryVariantId || selected[0].id)) || selected[0]);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(selected[0].id));
        history.replaceState({}, '', url);
      } catch (e) {}
    };
    const selectDefaultBundle = () => {
      const onePack = form.querySelector('input[name="nlc_bundle"][value="1"]');
      if (onePack) onePack.checked = true;
      refresh();
    };
    window.addEventListener('pageshow', selectDefaultBundle);
    form.addEventListener('change', event => {
      const select = event.target.closest('[data-shared-variant], select[data-variant-select]');
      if (select) galleryVariantId = String(select.value);
      refresh();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = root.dataset.adding;
      error.hidden = true;
      const card = cards.find(c => c.classList.contains('is-selected'));
      const counts = new Map();
      selections(card).forEach(v => counts.set(v.id, (counts.get(v.id) || 0) + 1));
      const items = [...counts].map(([id, quantity]) => ({id, quantity}));
      const code = card.dataset.bundle === '2' ? root.dataset.code2 : card.dataset.bundle === '3' ? root.dataset.code3 : '';
      try {
        const response = await fetch(root.dataset.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this product.');
        const destination = window.location.pathname + '?nlc_cart=open';
        if (root.dataset.discounts === 'true' && code) window.location.assign(root.dataset.root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination));
        else if (window.nlcOpenCart) { await window.nlcOpenCart(); refresh(); } else window.location.assign(root.dataset.root + 'cart');
      } catch (e) { error.textContent = e.message; error.hidden = false; refresh(); }
    });
    root.querySelectorAll('[data-gallery-index]').forEach(thumbnail => thumbnail.addEventListener('click', () => {
      activateGalleryIndex(Number(thumbnail.dataset.galleryIndex));
    }));
    initVariantDropdown();
    selectDefaultBundle();
  };
  document.querySelectorAll('[data-nlc-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nlc-pdp]').forEach(init));
})();
